import type { CasePriority } from '../../types/case-management'

export const PRIORITY_COLORS: Record<CasePriority, string> = {
  critical: 'bg-red-500',
  high: 'bg-orange-500',
  medium: 'bg-amber-500',
  low: 'bg-slate-400',
}

export const PRIORITY_VALUES: CasePriority[] = ['critical', 'high', 'medium', 'low']

export const INPUT_STYLE = {
  borderColor: 'var(--border-hover, rgba(28,31,46,0.18))',
  background: 'var(--bg-card, #ffffff)',
  color: 'var(--text, #1c1f2e)',
}
